import React from "react";
import styled from "styled-components";
import { Route, Switch, Redirect } from "react-router-dom";

import { COLORS } from "@onelogin/react-components";
import ResponsiveBlock from "./ResponsiveBlock";
import ScreenWrapper from "./ScreenWrapper";
import { PUBLIC_URL } from "../constants/Env";
import SecureNotesScreen from "./SecureNotesScreen/SecureNotesScreen";

const SecureNotesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  flex-grow: 1;
  background-color: ${COLORS.GRAY_COLORS.GRAY_98};
`;

const SecureNotesContent = () => {
  return (
    <SecureNotesWrapper>
      <ResponsiveBlock horizontal fillHeight maxHeight centered>
        <ScreenWrapper>
          <Switch>
            <Route path={`${PUBLIC_URL}/new`} component={SecureNotesScreen} />
            <Route
              exact
              path={`${PUBLIC_URL}/:id`}
              component={SecureNotesScreen}
            />
            <Route
              exact
              path={`${PUBLIC_URL}/share/:id`}
              component={SecureNotesScreen}
            />
            <Route
              exact
              path={`${PUBLIC_URL}/delete/:id`}
              component={SecureNotesScreen}
            />
            <Route path={`${PUBLIC_URL}`} component={SecureNotesScreen} />
            <Redirect path={`${PUBLIC_URL}*`} to={`${PUBLIC_URL}`} />
          </Switch>
        </ScreenWrapper>
      </ResponsiveBlock>
    </SecureNotesWrapper>
  );
};

export default SecureNotesContent;
